import { createAppContext } from '@abbott-components/core';
import { strings } from '../strings';

export const { AppProvider, Context } = createAppContext(strings);
